import React from "react";
import { formatCentsAsDollars, parseCurrencyToCents } from "../../../util/formatters";
import { CptFeeScheduleByTestPricingDetails } from "./CptFeeScheduleByTestPricingDetails";
import { toNumber } from "lodash-es";

export const EstimateInfoList = ({ biInfo, noMoopProvided = false, cptFeeScheduleByTest }) => {
  const hasFeeScheduleByTest = cptFeeScheduleByTest?.test_info?.length > 0;

  const cptCodeRatings = buildCptCodeRatings(biInfo);
  return (
    <>
      {hasFeeScheduleByTest ? (
        <CptFeeScheduleByTestPricingDetails cptFeeScheduleByTest={cptFeeScheduleByTest} cptContractedRates={biInfo.cpt_contracted_rates} />
      ) : (
        cptCodeRatings.map((cptCode) => (
          <li
            className="d-flex flex-row justify-content-between align-items-center mb-2"
            key={`cpt-code-${cptCode.code}`}
            id={`cpt-code-${cptCode.code}`}
          >
            <h5 className="text-muted fw-semibold">
              {cptCode.code} ( {cptCode.rate} ) x {cptCode.multiplier}
            </h5>
            <h5 className="text-dark fw-bold">{calculateTotalCptCost(cptCode.rate, cptCode.multiplier)}</h5>
          </li>
        ))
      )}

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"patient-responsibility-covered"}>
        <h5 className="text-muted fw-semibold">Total Covered Charges</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.estimated_patient_responsibility_covered)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"patient-responsibility-noncovered"}>
        <h5 className="text-muted fw-semibold">Total Non Covered Charges</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.estimated_patient_responsibility_noncovered)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"deductible-remaining"}>
        <h5 className="text-muted fw-semibold">Current Remaining Deductible</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.deductible_remaining_cents || 0)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"total-remaining"}>
        <h5 className="text-muted fw-semibold">Total Deductible</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.deductible_cents)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"moop"}>
        <h5 className="text-muted fw-semibold">Current Max Out of Pocket</h5>
        <h5 className="text-dark fw-bold">{noMoopProvided ? "NA" : formatCentsAsDollars(biInfo.moop_remaining_cents)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"total-moop"}>
        <h5 className="text-muted fw-semibold">Total Max Out of Pocket</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.moop_cents)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"coinsurance"}>
        <h5 className="text-muted fw-semibold">Coinsurance</h5>
        <h5 className="text-dark fw-bold">{biInfo.coinsurance}%</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"estimated-patient-responsibility"}>
        <h5 className="text-muted fw-semibold">Total Estimated Patient Responsibility</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.estimated_patient_responsibility_total)}</h5>
      </li>

      <li className="d-flex flex-row justify-content-between align-items-center mb-2" id={"estimated-total-healthplan-responsibility"}>
        <h5 className="text-muted fw-semibold">Total Charges Covered by HealthPlan</h5>
        <h5 className="text-dark fw-bold">{formatCentsAsDollars(biInfo.total_charges_covered_by_healthplan)}</h5>
      </li>
    </>
  );
};

const calculateTotalCptCost = (cptCodeCost, multiplier) => {
  return formatCentsAsDollars(parseCurrencyToCents(cptCodeCost) * toNumber(multiplier) || 0);
};

const getCptCodeMultiplier = (code, cptCodesWithMultiplier) => {
  const cptCode = cptCodesWithMultiplier.find((item) => item.startsWith(code));
  return cptCode?.split("x")[1] || 1;
};

const buildCptCodeRatings = (biInfo) => {
  const cptCodes = Object.keys(biInfo?.cpt_contracted_rates || {});
  return cptCodes.map((code) => ({
    code,
    rate: formatCentsAsDollars(biInfo.cpt_contracted_rates[code]),
    multiplier: getCptCodeMultiplier(code, biInfo.cpt_codes_with_multiplier),
  }));
};
